module.exports = __webpack_public_path__ + "static/media/instagram-square-brands.2dce0431.svg";